var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('thead',{staticClass:"report-header"},[_c('tr',[_c('th',[_vm._t("header")],2)])]),_c('tbody',{staticClass:"report-content"},[_c('tr',[_c('td',[_vm._t("content")],2)])]),_c('tfoot',{staticClass:"report-footer"},[_c('tr',[_c('td',[_c('div',{staticClass:"content"},[_vm._t("footer")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }